/* 资费相关 */

import request from '@/utils/request';
import { stringify } from 'qs';


/**
 * 资费列表
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function getPriceList(params: object) {
  return request(`/api/cloud_device/price/list/v2?${stringify(params)}`,{})
}

/**
 * 购买
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function cloudDevice(params: object) {
  return request(`/api/cloud_device/get`,{
    method: 'POST',
    body: params
  })
}

export async function wxConfig(url) {
  const href = window.location.origin + encodeURIComponent(url)
  return request(`api/wechat/sdk/get?signUrl=${href}`, {
    method: 'GET'
  })
}
